export enum PreprintRequestMachineState {
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
}
